window.initScrollLinks = () => {

  var scroll_links = document.querySelectorAll('a.smooth-scroll');

  if (scroll_links.length > 0) scroll_links.forEach(link => {
    if(link.classList.contains('smooth-scroll-enabled')) return;

    link.addEventListener('click', (e) => {
      link.classList.add('smooth-scroll-enabled');

      console.log('navigator.userAgent', navigator)

      e.preventDefault();
  
      var element = document.querySelector(e.target.closest('a.smooth-scroll').getAttribute('href'));
      var headerOffset = document.querySelector('sticky-header').offsetHeight;
  
      if (element) {

        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.scrollY - headerOffset - 15; 
        
        console.log('elementPosition', elementPosition, offsetPosition)

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });

        setTimeout(() => {
          element.focus();
        }, 500);
  
      }
    });
  });
}

window.initScrollLinks();


window.addEventListener('DOMContentLoaded', (event) => {
  var url = new URL(window.location.href);
  var params = new URLSearchParams(url.search);

  if (params.has('page')) {
    // Scroll the body to the ProductGridContainer
    const headerHeight = document.querySelector('header').offsetHeight;
    const ProductGridContainer = document.getElementById('ProductGridContainer');
    const productCount = document.querySelector('.product-grid-container .product-count__text');

    console.log('productCOUNT', productCount);

    if(ProductGridContainer){
      window.scroll({
        top: ProductGridContainer.offsetTop - headerHeight - 32,
        behavior: 'smooth'
      });

      productCount.focus(); 
    } 
  }

  if(params.has('login_success')){
    updateCart();
  }

});

async function getCart() {
  return fetch(`/cart.js`).then((response) => {
    return response.json();
  });
}

async function asyncForEach(array, callback) {
  for (const item of array) {
    await callback(item);
  }
}

async function updateCart(){
  var cart_items = document.querySelector('cart-items');
  if(cart_items){
    var cart = await getCart();

    if(cart.items.length > 0){
      var line = 1;
      await asyncForEach(cart.items, async (item) => {
        cart_items.updateQuantity(line, item.quantity)
        line++;
      });
    }
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {

  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  if(elementToFocus.classList.contains('no-focus')) return;

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.changeInfo = this.querySelector('.quantity-info');

  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
    this.input.textContent = `Quantity: ${this.input.value}`;
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if(event.target.name === 'plus'){
      this.input.stepUp();
      this.changeInfo.innerText = `Quantity Increased: ${this.input.value}`;
    } else {
      this.input.stepDown();
      this.changeInfo.innerText = `Quantity Decreased: ${this.input.value}`;
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.mainSummary = this.mainDetailsToggle.querySelector('summary');
    this.search = this.querySelector('.search__input');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();

  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) => {
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    });
    
    if(this.closest('header')){
      var button = this.closest('header').querySelector('button.header__icon--open-search');
      if(button) {
        button.addEventListener('click', this.onSearchClick.bind(this))
        button.addEventListener('touchstart', this.onSearchClick.bind(this))
      }
    }
    
    this.querySelectorAll(
      'button:not(.header__icon--open-search):not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.search__button):not(.reset__button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSearchClick(event) {

    this.mainDetailsToggle.open = true
    this.openMenuDrawer(this.mainSummary);
  
    setTimeout(() => {
      this.search.focus();
      this.search.click();
    }, 500);

  }

  onSummaryClick(event) {

    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details:not(.details-sale)').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    var summaries = this.querySelectorAll('summary.menu-drawer__menu-item');
    if(summaries.length > 0) {
      summaries.forEach(summary => {
        summary.addEventListener('click', (event) => {
          var clicked_summary = event.target.closest('summary');
          summaries.forEach(summary => {
            if(summary.id !== clicked_summary.id){
              summary.parentElement.removeAttribute('open')
            }
          });
        });
      });
    }
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    if(this.querySelector('[id^="ModalClose-"]')){
      this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    }

    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      // this.addEventListener('pointerup', (event) => {
      //   if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) {
      //     this.hide();
      //   }
      // });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button') || this.querySelector('a.button-unstyled');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
  
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderButtons = this.querySelector('.slider-buttons');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.quickView = this.closest('quick-add-modal') ? true : false;
    this.productInfo = this.closest('.product') ? true : false;
    this.recommendations = this.closest('product-recommendations') ? true : false;

    if(this.recommendations) return;
    this.slickInit()
  }

  slickGoToSlide(id){
    var selected_slide = this.querySelector('div[data-id="' + id + '"]');
    var parent_slide = selected_slide.closest('.slick-slide')

    if(parent_slide){
      $(this.slider).slick('slickGoTo', parent_slide.dataset.slickIndex);
    }
  }

  slickRefresh(){
    $(this.slider).slick('refresh');

    var buttons = this.slider.querySelectorAll('button');
    console.log(buttons);
    if(buttons.length > 0) buttons.forEach(button => button.tabIndex = "-1");
  
  }

  slickSetPosition(){
    $(this.slider).slick('setPosition');

    var buttons = this.slider.querySelectorAll('button');
    console.log(buttons);
    if(buttons.length > 0) buttons.forEach(button => button.tabIndex = "-1");
  }

  slickInit(){

    // if(this.sliderButtons) this.sliderButtons.remove();

    const next = `
    <button class="slick-next slick-arrow" aria-label="Slideshow Next" ${ this.dataset.vertical == 'true' ? 'tabindex="-1"' : ''}>
      <svg 
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        width="60" 
        height="60" 
        viewBox="0 0 60 60" 
        fill="none"
        aria-describedby="next-icon-title next-icon-description" 
        
      >
        <title id="next-icon-title">Slideshow Next Icon</title>
        <desc id="next-icon-description">Clicking this will rotate the slider to the next position</desc>
        <circle cx="30" cy="30.0005" r="30" fill="#003087"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M43.9277 30.26L32.6469 18.6313C32.5097 18.4545 32.3382 18.3073 32.142 18.1996C31.9356 18.0862 31.7073 18.0193 31.4724 18.0039C31.2375 17.9885 31.0024 18.0251 30.7831 18.1109C30.5639 18.1967 30.3662 18.3293 30.2029 18.4992C30.0397 18.669 29.9147 18.8719 29.8356 19.094C29.7566 19.3161 29.725 19.5526 29.743 19.7877C29.7609 20.0228 29.8279 20.2517 29.9399 20.459C30.0455 20.6544 30.189 20.8265 30.3621 20.9647L37.747 28.6011L17.0575 28.6011C16.6212 28.6011 16.2054 28.7789 15.9008 29.0913C15.5965 29.4033 15.4277 29.8239 15.4277 30.26C15.4277 30.696 15.5965 31.1166 15.9008 31.4286C16.2054 31.741 16.6212 31.9188 17.0575 31.9188L37.747 31.9188L30.3386 39.5795C30.0353 39.8927 29.8679 40.3141 29.8694 40.7503C29.8709 41.1865 30.0412 41.6067 30.3467 41.9177C30.6525 42.2292 31.0692 42.4056 31.5056 42.404C31.942 42.4024 32.3574 42.223 32.661 41.9094L33.4623 41.0818H33.4296L43.9277 30.26ZM31.5009 41.9159C31.1995 41.9159 30.9102 41.7936 30.6962 41.5757C30.4812 41.3568 30.3598 41.0593 30.3587 40.7486C30.3577 40.4379 30.477 40.1395 30.6905 39.9191L38.8992 31.4308H38.8979L30.6892 39.9191C30.4757 40.1395 30.3564 40.4379 30.3575 40.7486C30.3586 41.0593 30.4799 41.3568 30.6949 41.5757C30.8565 41.7403 31.0611 41.8503 31.2814 41.8943C31.3532 41.9087 31.4267 41.916 31.5009 41.9159ZM17.0588 31.4308C16.756 31.4308 16.4656 31.3074 16.2515 31.0878C16.0374 30.8683 15.9171 30.5705 15.9171 30.26C15.9171 29.9494 16.0374 29.6516 16.2515 29.4321C16.4656 29.2125 16.756 29.0892 17.0588 29.0892H17.0575C16.7547 29.0892 16.4643 29.2125 16.2502 29.4321C16.0361 29.6516 15.9158 29.9494 15.9158 30.26C15.9158 30.5705 16.0361 30.8683 16.2502 31.0878C16.4643 31.3074 16.7547 31.4308 17.0575 31.4308H17.0588ZM38.8979 29.0892L30.6892 20.6009C30.5577 20.5012 30.4486 20.3737 30.3693 20.227C30.29 20.0803 30.2424 19.9178 30.2296 19.7506C30.2169 19.5834 30.2393 19.4153 30.2954 19.2578C30.3515 19.1002 30.44 18.9569 30.5548 18.8374C30.6696 18.718 30.8081 18.6252 30.9609 18.5654C31.0913 18.5145 31.2294 18.4885 31.3685 18.4886C31.2298 18.4886 31.0921 18.5146 30.9622 18.5654C30.8094 18.6252 30.6709 18.718 30.5561 18.8374C30.4412 18.9569 30.3528 19.1002 30.2967 19.2578C30.2406 19.4153 30.2181 19.5834 30.2309 19.7506C30.2436 19.9178 30.2913 20.0803 30.3706 20.227C30.4498 20.3737 30.5589 20.5012 30.6905 20.6009L38.8992 29.0892H38.8979Z" fill="white"/>
      </svg>
    </button>`;

    const prev = `
    <button class="slick-prev slick-arrow" aria-label="Slideshow Previous" ${ this.dataset.vertical == 'true' ? 'tabindex="-1"' : ''}>
      <svg 
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        width="60" 
        height="60" 
        viewBox="0 0 60 60" 
        fill="none"
        aria-describedby="prev-icon-title prev-icon-description"
      >
        <title id="prev-icon-title">Slideshow Previous Icon</title>
        <desc id="prev-icon-description">Clicking this will rotate the slider to the previous position</desc>
        <circle cx="30" cy="30" r="30" transform="rotate(-180 30 30)" fill="#003087"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.0723 29.7405L27.3531 41.3692C27.4903 41.546 27.6619 41.6931 27.858 41.8009C28.0644 41.9143 28.2927 41.9812 28.5276 41.9966C28.7625 42.0119 28.9976 41.9753 29.2169 41.8896C29.4361 41.8038 29.6338 41.6711 29.7971 41.5013C29.9603 41.3315 30.0853 41.1285 30.1644 40.9065C30.2434 40.6844 30.275 40.4479 30.257 40.2128C30.2391 39.9777 30.1721 39.7488 30.0601 39.5415C29.9545 39.3461 29.811 39.174 29.6379 39.0357L22.253 31.3994L42.9425 31.3994C43.3788 31.3994 43.7946 31.2216 44.0992 30.9092C44.4035 30.5972 44.5723 30.1766 44.5723 29.7405C44.5723 29.3045 44.4035 28.8839 44.0992 28.5719C43.7946 28.2595 43.3788 28.0817 42.9425 28.0817L22.253 28.0817L29.6614 20.4209C29.9647 20.1078 30.1321 19.6864 30.1306 19.2502C30.1291 18.814 29.9588 18.3938 29.6533 18.0828C29.3475 17.7713 28.9308 17.5949 28.4944 17.5965C28.058 17.5981 27.6426 17.7775 27.339 18.0911L26.5377 18.9187L26.5704 18.9187L16.0723 29.7405ZM28.4991 18.0846C28.8005 18.0846 29.0898 18.2068 29.3038 18.4247C29.5188 18.6437 29.6402 18.9412 29.6413 19.2519C29.6423 19.5626 29.523 19.861 29.3095 20.0814L21.1008 28.5697L21.1021 28.5697L29.3108 20.0814C29.5243 19.861 29.6436 19.5626 29.6425 19.2519C29.6415 18.9412 29.5201 18.6437 29.3051 18.4247C29.1435 18.2602 28.9389 18.1502 28.7186 18.1062C28.6468 18.0918 28.5733 18.0845 28.4991 18.0846ZM42.9412 28.5697C43.244 28.5697 43.5344 28.6931 43.7485 28.9126C43.9626 29.1322 44.0829 29.43 44.0829 29.7405C44.0829 30.051 43.9626 30.3488 43.7485 30.5684C43.5344 30.788 43.244 30.9113 42.9412 30.9113L42.9425 30.9113C43.2453 30.9113 43.5357 30.788 43.7498 30.5684C43.9639 30.3488 44.0842 30.051 44.0842 29.7405C44.0842 29.43 43.9639 29.1322 43.7498 28.9126C43.5357 28.6931 43.2453 28.5697 42.9425 28.5697L42.9412 28.5697ZM21.1021 30.9113L29.3108 39.3996C29.4423 39.4993 29.5514 39.6268 29.6307 39.7735C29.71 39.9202 29.7576 40.0827 29.7704 40.2499C29.7831 40.4171 29.7607 40.5852 29.7046 40.7427C29.6485 40.9003 29.56 41.0436 29.4452 41.1631C29.3304 41.2825 29.1919 41.3753 29.0391 41.435C28.9087 41.486 28.7706 41.512 28.6315 41.5119C28.7702 41.5119 28.9079 41.4859 29.0378 41.435C29.1906 41.3753 29.3291 41.2825 29.4439 41.1631C29.5588 41.0436 29.6472 40.9003 29.7033 40.7427C29.7594 40.5852 29.7819 40.4171 29.7691 40.2499C29.7564 40.0827 29.7087 39.9202 29.6294 39.7735C29.5502 39.6268 29.4411 39.4993 29.3095 39.3996L21.1008 30.9113L21.1021 30.9113Z" fill="white"/>
      </svg>
    </button>`;

    var slidesToShowDesktop = Math.max(parseInt(this.dataset.columnsDesktop), 1);
    var slidesToShowTablet = Math.max(parseInt(this.dataset.columnsTablet), 1);
    var slidesToShowMobile = Math.max(parseInt(this.dataset.columnsMobile), 1);
    
    var desktopSettings = {
      slidesToShow:  Math.max(parseInt(this.dataset.columnsDesktop) - 1, 1),
      autoplay: this.dataset.autoplay == 'true' ? true : false,
      dots: this.dataset.dotsTablet == 'true' ? true : false,
    };

    var mobileSettings = {
      slidesToShow: slidesToShowMobile,
      slidesToScroll: 1,
      vertical: false,
      arrows: this.dataset.arrowsMobile == 'true' ? true : false,
      dots: this.dataset.dotsMobile == 'true' ? true : false,
      autoplay: this.dataset.autoplayMobile == 'true' ? true : false
    }

    if(this.dataset.vertical) {
      const new_next = `
      <button class="slick-next slick-arrow" aria-label="Slideshow Next" tabindex="-1">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M7.72 14.53a.75.75 0 0 1 0-1.06l3.47-3.47-3.47-3.47a.75.75 0 0 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0Z"/></svg>
      </button>`;

      const new_prev = `
      <button class="slick-prev slick-arrow" aria-label="Slideshow Previous" tabindex="-1">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M11.764 5.204a.75.75 0 0 1 .032 1.06l-3.516 3.736 3.516 3.736a.75.75 0 1 1-1.092 1.028l-4-4.25a.75.75 0 0 1 0-1.028l4-4.25a.75.75 0 0 1 1.06-.032Z"/></svg>
      </button>`;

      mobileSettings['prevArrow'] = new_prev;
      mobileSettings['nextArrow'] = new_next;
    }
    
    var tabletSettings = {
      slidesToShow: slidesToShowTablet,
      arrows: this.dataset.arrowsTablet == 'true' ? true : false,
      dots: this.dataset.dotsTablet == 'true' ? true : false,
      autoplay: this.dataset.autoplayTablet == 'true' ? true : false
    }

    if(this.dataset.sliderMobile == 'false') mobileSettings = "unslick"

    var options = {
      infinite: this.dataset.infinite == 'false' ? false : true,
      touchThreshold: 100,
      slidesToShow: slidesToShowDesktop,
      slidesToScroll: this.dataset.slidesToScroll ? parseInt(this.dataset.slidesToScroll) : 1,
      adaptiveHeight: true,
      arrows: this.dataset.arrows == 'true' ? true : false,
      dots: this.dataset.dots == 'true' ? true : false,
      prevArrow: prev,
      nextArrow: next,
      autoplay: this.dataset.autoplay == 'true' ? true : false,
      draggable: true,
      responsive: [
        {
          breakpoint: 1367,
          settings: desktopSettings
        },
        {
          breakpoint: 1025,
          settings: tabletSettings
        },
        {
          breakpoint: 989,
          settings: tabletSettings
        },
        {
          breakpoint: this.dataset.breakpointMobile ? parseInt(this.dataset.breakpointMobile) : 749,
          settings: mobileSettings
        }
      ]
    }

    if(this.classList.contains('announcement-bar')) {
      options['prevArrow'] = `
        <button class="slick-prev slick-arrow" aria-label="Slideshow Prev" ${ this.dataset.vertical == 'true' ? 'tabindex="-1"' : ''}>
          <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
          </svg>
        </button>`;

      options['nextArrow'] = `
      <button class="slick-next slick-arrow" aria-label="Slideshow Next" ${ this.dataset.vertical == 'true' ? 'tabindex="-1"' : ''}>
        <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
        </svg>
      </button>`;
    }

    if(this.dataset.asNavFor) {
      options['asNavFor'] = this.dataset.asNavFor
      options['instructionsText'] = 'Changing this thumbnail carousel will focus on the correct image within the main product carousel and vis versa.'
      options['regionLabel'] = 'Product Image carousel'
    }

    if(this.dataset.vertical) {
      options['vertical'] = true
      options['arrows'] = true
      options['verticalSwiping'] = true
    }

    $(this.slider).slick(options);
    this.slider.setAttribute('aria-busy', 'false');

    if(this.dataset.asNavFor) {
      var buttons = this.slider.querySelectorAll('button');
      if(buttons.length > 0) buttons.forEach(button => button.tabIndex = "-1");
    }
    
    $(this.slider).on('afterChange', (event) => {      
      var element = this.querySelector('.slick-current.slick-active .card');

      if(element) element.focus(); 

      if(this.dataset.asNavFor) {
        var buttons = this.slider.querySelectorAll('button');
        if(buttons.length > 0) buttons.forEach(button => button.tabIndex = "-1");
      }

      if(this.dataset.vertical) {
        this.querySelectorAll('button.thumbnail').forEach(button => button.addEventListener('click', (event) => {
          var list_item = event.target.closest('.slick-slide');
  
          console.log('list_item', list_item);
          console.log('list_item', list_item.dataset.slickIndex);
  
          $(this.dataset.asNavFor).slick('slickGoTo', parseInt(list_item.dataset.slickIndex))
        }));
      }

    });

    // $(this.slider).on('breakpoint', function(event, slick, breakpoint) {
    //   console.log('breakpoint', event);
    //   console.log('breakpoint', slick);
    //   console.log('breakpoint', breakpoint);
    // });

    if(this.dataset.vertical) {
      this.querySelectorAll('button.thumbnail').forEach(button => button.addEventListener('click', (event) => {
        var list_item = event.target.closest('.slick-slide');

        console.log('list_item', list_item);
        console.log('list_item', list_item.dataset.slickIndex);

        $(this.dataset.asNavFor).slick('slickGoTo', parseInt(list_item.dataset.slickIndex))
      }));
    }
    
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();

    console.log('THIS', this)

    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    console.log('this.sliderControlWrapper', this.querySelector('.slider-buttons'))

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {

    console.log('event', event)

    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const media_gallery = document.querySelector('media-gallery');
    const sliders = media_gallery.querySelectorAll('slider-component');
    sliders.forEach(slider => slider.slickGoToSlide(this.currentVariant.featured_media.id));

    // const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    // mediaGalleries.forEach((mediaGallery) =>
    //   mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    // );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource2 = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}-2`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const skuDestination2 = document.getElementById(`Sku-${this.dataset.section}-2`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (skuSource2 && skuDestination2) {
          skuDestination2.innerHTML = skuSource2.innerHTML;
          skuDestination2.classList.toggle('hidden', skuSource2.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {

          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            const slider = this.querySelector('slider-component');
            if(slider) slider.slickInit();
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
          
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


class DocumentsComponent extends HTMLElement {
  constructor() {
    super();

    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js';

    this.slides = this.querySelectorAll('.slider__slide');
    if(this.slides.length > 0){
      this.pdfs = Array.from(this.slides).map(slide => {
        return {
          pdf_url: slide.dataset.pdfUrl,
          canvas_id: `pdf-canvas-${slide.dataset.index}`
        }
      });

      if(this.pdfs.length > 0){
        this.pdfs.forEach(pdf => this.loadPDFThumbnail(pdf.pdf_url, pdf.canvas_id));
      }

    }
  }

  loadPDFThumbnail(pdfUrl, canvasId) {
    const loadingTask = pdfjsLib.getDocument(pdfUrl);
    
    loadingTask.promise.then(pdf => {
      // Get the first page
      pdf.getPage(1).then(page => {
        const scale = 1.5;  // Scale for the image quality
        const viewport = page.getViewport({ scale });
        
        const canvas = document.getElementById(canvasId);
        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;
  
        const renderContext = {
          canvasContext: context,
          viewport: viewport
        };
  
        page.render(renderContext).promise.then(() => {
          console.log('Thumbnail rendered for ' + canvasId);
        });
      });
    }).catch(err => {
      console.error('Error loading PDF: ' + err);
    });
  }

}

customElements.define('documents-component', DocumentsComponent);


class PDFCanvas extends HTMLElement {
  constructor() {
    super();

    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js';

    this.pdfUrl = this.dataset.pdfUrl;
    this.canvasId = this.dataset.canvasId;
  }

  connectedCallback() {
    this.loadPDFThumbnail(this.pdfUrl, this.canvasId);
  }

  loadPDFThumbnail(pdfUrl, canvasId) {

    const loadingTask = pdfjsLib.getDocument(pdfUrl);
    
    loadingTask.promise.then(pdf => {
      // Get the first page
      pdf.getPage(1).then(page => {
        const scale = 1.5;  // Scale for the image quality
        const viewport = page.getViewport({ scale });
        
        const canvas = document.getElementById(canvasId);
        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;
  
        const renderContext = {
          canvasContext: context,
          viewport: viewport
        };
  
        page.render(renderContext).promise.then(() => {
          console.log('Thumbnail rendered for ' + canvasId);
        });
      });
    }).catch(err => {
      console.error('Error loading PDF: ' + err);
    });
  }

}

customElements.define('pdf-canvas', PDFCanvas);

class ProductTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const tabButtons = this.querySelectorAll(".product-tab");
    const contents = this.querySelectorAll(".tab-content");

    if(tabButtons.length > 1){
      tabButtons.forEach(tab => {
        tab.addEventListener('click', (event) => {

          event.preventDefault();
          const target = event.target;

          const id = target.getAttribute('href');

          if (id) {
            tabButtons.forEach(tab => tab.classList.remove('active'));
            target.classList.add("active");

            contents.forEach(content => content.classList.remove('active'));
            this.querySelector(id).classList.add("active")

            var slideshow = this.querySelector('slider-component');
            if(slideshow) slideshow.slickRefresh();

          }

        });
      });
    }

    if(contents.length > 0){
      contents.forEach(content => {

        var content_area = content.querySelector('.metafield-rich_text_field');
        if(!content_area) return;
        const childNodes = content_area.childNodes;

        // Create a new div element
        const hiddenDiv = document.createElement('div');
        hiddenDiv.classList.add('extra-content')
        hiddenDiv.style.display = 'none';

        let shouldMove = false;
    
        // Loop through child nodes
        for (let i = 0; i < childNodes.length; i++) {
            if (shouldMove) {
                // Clone the child node and append it to the hidden div
                hiddenDiv.appendChild(childNodes[i].cloneNode(true));
                // Remove the original child node
                content_area.removeChild(childNodes[i]);
                // Decrement the counter since we removed a node
                i--;
            }
            // Check if we have moved past the first two nodes
            if (!shouldMove && i > 1) {
                shouldMove = true;
            }
        }
        
        // Append the hidden div after the content area
        content_area.parentNode.insertBefore(hiddenDiv, content_area.nextSibling);

        var read_more = content.querySelector('.read-more');
        if (read_more) {
          // Hide the read more link if hiddenDiv is empty
          if (hiddenDiv.textContent.trim() === '') {
              read_more.style.display = 'none';
          }
      
          read_more.addEventListener('click', (event) => {
              // Toggle display of the hidden div
              if (hiddenDiv.style.display === 'none') {
                  hiddenDiv.style.display = 'block';
                  read_more.textContent = 'Read Less';
              } else {
                  hiddenDiv.style.display = 'none';
                  read_more.textContent = 'Read More';
              }

              trapFocus(read_more.closest('.product-tab-content'), read_more.closest('.product-tab-content').querySelector('.tab-content'));

          });
      }
      });
    }
  }
}

customElements.define('product-tabs', ProductTabs);


class BackToTop extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Attach click event listener to the button
    this.querySelector('button').addEventListener('click', () => {
      this.scrollToTop();
    });

    // Hide or show the button based on scroll position
    window.addEventListener('scroll', () => {
      if (window.scrollY > 20) {
        this.style.display = 'block';
      } else {
        this.style.display = 'none';
      }
    });
  }

  // Function to smoothly scroll to the top
  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

// Define the custom element
customElements.define('back-to-top', BackToTop);


class SaleSwitch extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', (evt) => {
      // Retrieve the URLs from dataset attributes
      const collectionUrl = this.dataset.collection;
      const collectionSaleUrl = this.dataset.collectionSale;

      var url = new URL(window.location.href);

      // Check if the checkbox is checked
      if (evt.target.checked) {
        // Navigate to collectionSaleUrl if checked
        setTimeout(() => {
          window.location.href = collectionSaleUrl + url.search;
        }, 300);
      } else {
        setTimeout(() => {
          window.location.href = collectionUrl + url.search;
        }, 300);
      }
    });
  }

}

// Define the custom element
customElements.define('sale-switch', SaleSwitch);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });

  }

  async asyncForEach(array, callback) {
    for (const item of array) {
      await callback(item);
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    if(!event.target.closest('.cart-items')) return;
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      // {
      //   id: 'main-cart-footer',
      //   section: document.getElementById('main-cart-footer').dataset.id,
      //   selector: '.js-contents',
      // },
    ];
  }

  renderContents(parsedState){

    this.getSectionsToRender().forEach((section) => {

      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        
        var getSectionInnerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );

      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
    });

  }

  updateQuantity(line, quantity, name, variantId) {

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {

          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            
            var getSectionInnerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          // cartDrawerWrapper
          //   ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
          //   : lineItem.querySelector(`[name="${name}"]`).focus();

            document.querySelector('.drawer__heading').focus()

        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {

         

          document.querySelector('.drawer__heading').focus()

          // trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

      })
      .catch((e) => {
        console.log('ERROR', e)
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        window.ci_view_cart_click();
        window.begin_checkout_button_click();
      });
  }

  updateLiveRegions(line, message) {

    const lineItemError = document.getElementById(`Line-item-error-${line}`)
    const lineItemErrorDrawer = document.getElementById(`CartDrawer-LineItemError-${line}`);

    if (lineItemError) {
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message
    };

    if (lineItemErrorDrawer) {
      lineItemErrorDrawer.querySelector('.cart-item__error-text').innerHTML = message
    };

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

class CustomerForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.submitButton = this.querySelector('[type="submit"]');
    this.fields = this.querySelectorAll('input.required, select.required');
    this.errorFields = this.querySelector('.error-fields');
  }

  enableLoading(){
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading__spinner').classList.remove('hidden');
  }

  disableLoading(){
    this.submitButton.classList.remove('loading');
    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
    this.querySelector('.loading__spinner').classList.add('hidden');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    evt.stopImmediatePropagation();

    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
    this.enableLoading();

    const formData = new FormData(this.form);
    let isFormValid = this.validateForm(formData);
    if(!isFormValid) {
      this.disableLoading();
      return;
    }

    window.ci_form_success(this.form)
    this.form.submit();
  }

  validateForm(formData){

    for (const entry of formData.entries()) {
      console.log(entry);
    }
  
    let isFormValid = true;
    let field_errors = [];

    this.fields.forEach(field => {
      switch (field.type) {
        case 'email':
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (field.value.trim() === '') {
            isFormValid = false;
            field_errors.push({
              field,
              message: 'Email is required'
            });
          } else if (!emailRegex.test(field.value)) {
            isFormValid = false;
            field_errors.push({
              field,
              message: 'Please enter a valid email (Format: name@url.com)'
            })
          }
          
          break;
        case 'text':

          var additional_text = ''

          if(field.name == 'address[address1]'){
            var additional_text = '(Format: 2237 Pembina Hwy)'
          } else if(field.name == 'address[zip]'){
            var additional_text = '(Format: R3T 2H1)'
          }

          if (field.name == 'address[zip]') {
            const canadianPostalCodeRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
            const americanZipCodeRegex = /^\d{5}(-\d{4})?$/;
          
            if (!canadianPostalCodeRegex.test(field.value) && !americanZipCodeRegex.test(field.value)) {
              isFormValid = false; // Mark form as invalid
              field_errors.push({
                field,
                message: 'Please format like postal code (e.g., R3T 2H1 or 12345-6789)'
              });
            }
          }

          if (field.value.trim() === '') {
            isFormValid = false;
            field_errors.push({
              field,
              message: 'Field is required ' + additional_text
            });
          }
          break;
        case 'tel':
          if (field.value.trim() === '') {
            isFormValid = false;
            field_errors.push({
              field,
              message: 'Phone number is required (Format: (999) 999-9999)'
            });
          }
          break;
        case 'password':
          if (field.value.trim() === '') {
            isFormValid = false;
            field_errors.push({
              field,
              message: 'Password is required'
            });
          }
          break;
        case 'input':
          if (field.value.trim() === '') {
            isFormValid = false;
            field_errors.push({
              field,
              message: 'Please Select'
            })
          }
          break;
        case 'select':
          if (field.value === '') {
            isFormValid = false;
            field_errors.push({
              field,
              message: 'Please Select'
            })
          }
          break;
        default:
          break;
      }
    });
      
    let error_fields = this.form.querySelectorAll('.form__message');
    error_fields.forEach(field => field.remove());
    this.errorFields.innerText = '';

    this.fields.forEach((field) => {
      const parentElement = field.parentElement
      parentElement.classList.remove('invalid');
    });

    if(field_errors.length > 0) {

      var header = document.createElement('h3'); 
      header.classList.add('error-header');
      header.innerText = `There are ${field_errors.length} error(s) found in the information you submitted.`
      header.ariaLabel = `There are ${field_errors.length} errors found in the information you submitted.`;
      header.tabIndex = "-1"

      window.ci_form_error(this.form, header.innerText)

      var ulElement = document.createElement('ul');
      field_errors.forEach(function(error) {
        var liElement = document.createElement('li');
        liElement.innerHTML = `<a class="link smooth-scroll" href="#${error.field.id}">${error.field.placeholder}: ${error.message}</a>`; // Customize the format of the error message as needed
        ulElement.appendChild(liElement);
      });

      this.errorFields.appendChild(header);
      this.errorFields.appendChild(ulElement);
    
      // Display new error messages
      field_errors.forEach((error) => {
        const { field, message } = error;
        const parentElement = field.parentElement;
        parentElement.classList.add('invalid');
    
        // Create SVG element
        const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svgElement.setAttribute("aria-hidden", "true");
        svgElement.setAttribute("focusable", "false");
    
        // Create 'use' element
        const useElement = document.createElementNS("http://www.w3.org/2000/svg", "use");
        useElement.setAttribute("href", "#icon-error");
    
        // Append 'use' element to SVG
        svgElement.appendChild(useElement);
    
        const errorSpan = document.createElement('span');
        errorSpan.classList.add('form__message');
        
        const errorSpanInner = document.createElement('span');
        errorSpanInner.innerText = message
        // Append SVG before error message
        errorSpan.appendChild(svgElement);
        errorSpan.appendChild(errorSpanInner);
    
        // Insert errorSpan after parentElement
        parentElement.insertAdjacentElement('afterend', errorSpan);
      });

      var elementPosition = this.errorFields.getBoundingClientRect().top;
      var headerOffset = document.querySelector('sticky-header').offsetHeight;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset - 15;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });

      this.errorFields.querySelector('.error-header').focus()

      window.initScrollLinks();

    }
  
    return isFormValid;
  
  }

}

customElements.define('customer-form', CustomerForm);

class RedirectTool extends HTMLElement {
  constructor() {
    super();

    console.log('THISSSSS', this)

    setTimeout(() => {
      window.location.href = this.dataset.url;
    }, this.dataset.delay);
    
  }

}

customElements.define('redirect-tool', RedirectTool);


class DawnSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('dawn-slider-component', DawnSliderComponent);

class DawnSlideshowComponent extends DawnSliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('dawn-slideshow-component', DawnSlideshowComponent);